import React from 'react';
import { Button } from 'react-bootstrap';

export default function FallbackManageColumns({ onOpenModal }) {
    return (
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
            textAlign: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            border: '1px solid #dee2e6'
        }}>
            <div style={{ marginBottom: '15px' }}>
                <i className="fa fa-eye-slash" style={{ fontSize: '24px', color: '#6c757d' }}></i>
            </div>
            <h6 style={{ marginBottom: '10px', color: '#495057' }}>
                All Columns Hidden
            </h6>
            <p style={{ fontSize: '14px', color: '#6c757d', marginBottom: '15px' }}>
                All table columns are currently hidden. Click below to manage column visibility.
            </p>
            <Button 
                variant="primary" 
                size="sm"
                onClick={onOpenModal}
                style={{ minWidth: '150px' }}
            >
                <i className="fa fa-cog me-2"></i>
                Manage Columns
            </Button>
        </div>
    );
} 